import "./App.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import { Routes, Route } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

//Pages
import Landing from "./pages/Landing";
import Group from "./pages/Group";
import VerifyEmail from "./pages/VerifyEmail";
import Invite from "./pages/Invite";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DeleteApp from "./pages/DeleteApp";
import Footer from "./components/Footer";
import Header from "./components/Header";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATSXW-I2u83g5XtdhglDsCKhrFW6Ji9vc",
  authDomain: "boque-51d96.firebaseapp.com",
  projectId: "boque-51d96",
  storageBucket: "boque-51d96.firebasestorage.app",
  messagingSenderId: "486476245153",
  appId: "1:486476245153:web:426d681b90636ca25568e0",
  measurementId: "G-1FV1D0F7MS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

function App() {
  return (
    <div
      className="min-vh-100 d-flex flex-column 
    justify-content-between"
    >
      <QueryClientProvider client={queryClient}>
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="contact" element={<Contact />} />
            <Route path="about" element={<About />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="delete-app" element={<DeleteApp />} />
            <Route path="group/:username" element={<Group />} />
            <Route path="verify-email/:token" element={<VerifyEmail />} />
            <Route path="invite/:inviteToken" element={<Invite />} />
          </Routes>
        </div>
        <Footer />
      </QueryClientProvider>
    </div>
  );
}

export default App;
